import { getFeatures, type Feature } from '@i22team/status-toolbar';
import { useRuntimeConfig } from '#imports';

type UsedFeatures = {
  simulateBeQueue: Feature;
  dcbMailSent: Feature;
  dcbSpecialEnded: Feature;
  mockOrderSummary: Feature;
};

export const useFeatures = () => {
  const config = useRuntimeConfig();
  const isProduction = config.public.applicationEnv === 'production';

  const featureList: UsedFeatures = {
    simulateBeQueue: {
      enabled: false,
    },
    dcbMailSent: {
      enabled: false,
    },
    dcbSpecialEnded: {
      enabled: false,
    },
    mockOrderSummary: {
      enabled: false,
    },
  };

  const features = getFeatures(featureList, isProduction);

  return {
    features,
  };
};
